import { useTranslation } from "react-i18next";
import { Seo } from "../components/layout/Seo";
import { Section } from "../components/ui/Section";
import { organization } from "../content/config";

export function Transparency() {
  const { t } = useTranslation();
  const legalRows = [
    ["Public name", organization.brandName],
    ["Initiative descriptor", organization.publicDescriptor],
    ["Registration status", organization.registrationStatus === "registered" ? "Registered" : "In development"],
    ...(organization.registrationStatus === "registered" ? [["Legal name", organization.legalNameEn], ["Romanian name", organization.legalNameRo]] : []),
    ["Registration number", organization.registrationNumber],
    ["Registration date", organization.registrationDate],
    ["Address", organization.address]
  ].filter(([, value]) => value);

  const principles = [
    [t("transparency.governance"), "Decision-making, reports and public materials are structured for review as the institution matures."],
    [t("transparency.conflict"), "Potential conflicts are handled through role clarity, disclosure and separation between assessment, supplier selection and financing preparation."],
    [t("transparency.neutrality"), "Assessment begins with the problem and evidence, not with a preselected vendor or technology."],
    [t("transparency.partner"), "Partner selection should be transparent, relevant to the use case and documented."],
    [t("transparency.funding"), "Funding sources and constraints should be disclosed where they affect programme design or public claims."],
    [t("transparency.privacy"), "Contact data and submitted documents are processed for assessment and collaboration purposes only."]
  ];

  return (
    <>
      <Seo title={t("transparency.title")} description={t("transparency.intro")} />
      <Section title={t("transparency.title")} intro={t("transparency.intro")} className="pt-[calc(var(--header-height)+72px)]">
        <div className="max-w-3xl border border-line bg-surface p-6">
          <h2 className="mb-5 text-2xl font-bold">{t("transparency.legal")}</h2>
          <dl className="grid gap-4">
            {legalRows.map(([label, value]) => (
              <div key={label} className="grid gap-1 border-b border-line pb-3 sm:grid-cols-[200px_1fr]">
                <dt className="text-sm font-bold text-ink-secondary">{label}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </Section>
      <Section className="bg-bg-secondary">
        <div className="grid gap-4 md:grid-cols-2">
          {principles.map(([title, copy]) => (
            <div key={title} className="border border-line bg-surface p-6">
              <h2 className="mb-3 text-xl font-bold">{title}</h2>
              <p className="leading-7 text-ink-secondary">{copy}</p>
            </div>
          ))}
        </div>
      </Section>
      <Section title={t("transparency.reports")}>
        <p className="max-w-2xl rounded-xl border border-line bg-surface p-6 text-ink-secondary">{t("common.noReports")}</p>
      </Section>
    </>
  );
}
